import { Navigate, useNavigate } from "react-router-dom";
import { Table } from "../../../../components/Functional/Table";
import { Button } from "../../../../components/ui";
import { ResponsivePrimaryNav } from "../../../../components/ui/ResponsivePrimaryNav";
import useUser, { USER_ROLES } from "../../../../hooks/useUser";
import { FETCH_EMAIL_USAGE_PAGE } from "./query";

const OwnerMailings = ({ values }) => {
  const navigate = useNavigate();
  return values.userId == null ? null : (
    <Button
      label="View mailings"
      onClick={() => navigate(`/email?owner=${values.userId}`)}
    />
  );
};

const headers = [
  { label: "Owner", name: "ownerLabel", type: "label", rowClass: "!pl-0" },
  { label: "Email", name: "ownerEmail", type: "label", widthInPx: null },
  { label: "Mailings", name: "total", type: "label" },
  { label: "Sent", name: "sent", type: "label" },
  { label: "Failed", name: "failed", type: "label" },
  { label: "Latest update", name: "lastUpdatedAt", type: "date" },
  { label: "Action", name: "action", type: "custom", component: OwnerMailings },
];

const Usage = () => {
  const { hasRole } = useUser({ withRoles: true });
  const isAdministrator =
    hasRole(USER_ROLES.ADMIN) || hasRole(USER_ROLES.SUPER_ADMIN);
  if (!isAdministrator) return <Navigate to="/email" replace />;

  return (
    <div className="min-w-0 flex-1">
      <ResponsivePrimaryNav>
        <h1 className="text-xl font-semibold">Usage by owner</h1>
      </ResponsivePrimaryNav>
      <main className="mt-6 px-4 sm:px-6 lg:px-8">
        <p className="mb-4 text-sm text-gray-600">
          Mailing counts include archived emails. Latest update shows mailing
          activity, not who is currently online. Sent and failed counts reflect
          current status.
        </p>
        <Table
          isSubTable
          FETCH_QUERY={FETCH_EMAIL_USAGE_PAGE}
          dataKey="emailUsage"
          headers={headers}
          limit={25}
          variant="dynamicHeight"
          fetchPolicy="cache-and-network"
          pollInterval={30000}
          showNewDataColumn={false}
          emptyMessage="No mailing usage found."
        />
      </main>
    </div>
  );
};

export default Usage;
